import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { ReportType } from '@/app/constants/reportType'

/**
 * Opcje wydruku ustawione pod wierszem raportu - odpowiednik cache modeli
 * w ReportFactory WPF (Create(type, useCache: true)). Wydruk grupowy bierze
 * je dla kazdego zaznaczonego raportu. Trzymane w pamieci jak w WPF, wspolne
 * dla list wszystkich/ulubionych/do wyslania; opcje z innej firmy sa nieaktualne.
 */
type ReportParams = Record<string, any>

type State = {
  paramsByReport: Partial<Record<ReportType, ReportParams>>
  ownerCompanyId: string | undefined
}

type Actions = {
  setParams: (report: ReportType, params: ReportParams) => void
  syncCompany: (companyId: string) => void
}

export const useReportParamsStore = create<State & Actions>()(
  devtools(
    (set) => ({
      paramsByReport: {},
      ownerCompanyId: undefined,

      setParams: (report, params) =>
        set(
          (s) => ({ paramsByReport: { ...s.paramsByReport, [report]: params } }),
          false,
          'setParams',
        ),

      syncCompany: (companyId) =>
        set(
          (s) =>
            s.ownerCompanyId === companyId
              ? {}
              : { ownerCompanyId: companyId, paramsByReport: {} },
          false,
          'syncCompany',
        ),
    }),
    { name: 'EasyTacho', store: 'printout-report-params' },
  ),
)
